/**
 * This file load jQuery and jQueryUI and adds it to the window object. By doing so, jQuery and jQuery UI extensions
 *      became available globally and it's functions such as dialog() might be called from blade files.
 *      Also, we are loading only the extensions which are needed in 'chorvatkse' in 'hr' locale.
 */
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui';

// import 'jquery-ui/ui/widgets/autocomplete';
// import 'jquery-ui/ui/widgets/dialog';

declare global {
    interface Window {
        $: any;
        jQuery: any;
    }
}

window.$ = window.jQuery = $;